<template>
  <div class="search-filter">
    <el-row :gutter="12">
      <el-col
        v-for="(filterItem, index) of searchFilterList"
        :key="index"
        :span="filterItem.span || 4"
        :lg="filterItem.lg"
        :sm="filterItem.sm"
        :md="filterItem.md"
        class="mb-2 filter-item"
      >
        <template v-if="filterItem.type === 'input'">
          <template v-if="filterItem.hasMaxMinValue">
            <el-col :span="11">
              <el-input
                :placeholder="filterItem.start || filterItem.label"
                v-model="filterItem.min"
                @blur="onFiledChange(filterItem.min, filterItem, 'min')"
              />
            </el-col>
            <el-col :span="2" class="text-center">~</el-col>
            <el-col :span="11">
              <el-input
                :placeholder="filterItem.end || filterItem.label"
                v-model="filterItem.max"
                @blur="onFiledChange(filterItem.max, filterItem, 'max')"
              />
            </el-col>
          </template>
          <template v-else>
            <el-input
              @blur="onFiledChange(filterItem.value, filterItem)"
              v-model="filterItem.value"
              :placeholder="filterItem.label"
            />
          </template>
        </template>
        <template v-else-if="filterItem.type === 'select'">
          <el-select
            class="w-full"
            filterable
            :clearable="filterItem.clearable != undefined ? filterItem.clearable : false"
            v-model="filterItem.value"
            :multiple="filterItem.multiple"
            :collapse-tags="filterItem.collapseTags || false"
            :placeholder="filterItem.label"
            @change="onFiledChange($event, filterItem)"
            :popper-append-to-body="false"
          >
            <el-option v-for="option of filterItem.options" :key="option.value" :label="option.label" :value="option.value" />
          </el-select>
        </template>
        <template v-else-if="filterItem.type === 'cascader'">
          <el-cascader
            filterable
            clearable
            @change="onFiledChange($event, filterItem)"
            :placeholder="filterItem.label"
            class="w-full"
            v-model="filterItem.value"
            :options="filterItem.options"
            :props="{
              expandTrigger: 'hover',
              multiple: filterItem.multiple,
              value: filterItem.key || 'id',
              label: filterItem.content || 'content',
              children: filterItem.children || 'nextLevelOptions'
            }"
            :append-to-body="false"
          />
        </template>
        <template v-else-if="filterItem.type === 'date-picker'">
          <el-date-picker
            @change="onFiledChange($event, filterItem)"
            class="w-full"
            style="width: 100%"
            v-model="filterItem.value"
            :type="filterItem.dateType || 'datetimerange'"
            range-separator="至"
            :value-format="filterItem.format"
            :format="filterItem.format"
            :start-placeholder="filterItem.start || `${filterItem.label}开始日期`"
            :end-placeholder="filterItem.end || `${filterItem.label}结束日期`"
            :placeholder="filterItem.label"
            :append-to-body="false"
          >
          </el-date-picker>
        </template>
        <template v-else-if="filterItem.type === 'settle-date-type'">
          <subjection-date-type
            ref="subDate"
            v-model="filterItem.value"
            :date-type.sync="filterItem.dateType"
            @change="onFiledChange(filterItem.value, filterItem)"
          />
        </template>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { validatenull } from '@/assets/js/validate'
import { diffContentEqual } from '@/assets/js/diff'
import SubjectionDateType from '@/views/home/cost-settlement/components/SubjectionDateType'

export default {
  name: 'search-filter',
  components: { SubjectionDateType },
  props: {
    changeHandelFunction: {
      type: Function,
      default: null
    },
    searchFilters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    searchFilterList() {
      return this.searchFilters.filter((m) => !m.hide)
    }
  },
  created() {
    this.oldData = {}
  },
  methods: {
    onFiledChange(e, field, value = 'value') {
      let data = {}
      let searchs = this.searchFilters.filter(fieldInfo => {
        return !fieldInfo.hide
      })
      const changeProps = []
      searchs.forEach(searchField => {
        let newValue = searchField[value]
        let oldValue = this.oldData[searchField.prop]
        // let hasOldValue = !validatenull(oldValue)
        if (validatenull(newValue) && newValue !== null) {
          if (!validatenull(oldValue)) {
            data[searchField.prop] = newValue
            changeProps.push(searchField.prop)
          }
          return
        }

        if (diffContentEqual(newValue, oldValue)) {
          data[searchField.prop] = oldValue
          return
        }

        changeProps.push(searchField.prop)
        // if (!validatenull(value)) {
        if (searchField.lastParams) {
          // 级联题 后台要求返回 最后一项的 id
          data[searchField.prop] = searchField.value.map(i => i.slice().pop())
        } else if (searchField.hasMaxMinValue) {
          let val = searchField.value // hasMaxMinValue
          if (Array.isArray(val)) {
            let [min, max] = val
            data[searchField.prop + 'Min'] = min
            data[searchField.prop + 'Max'] = max
          } else {
            let min = parseInt(searchField.min),
              max = parseInt(searchField.max)
            let _min = Math.min(max, min)
            let _max = Math.max(max, min)
            data[searchField.prop + 'Min'] = _min
            data[searchField.prop + 'Max'] = _max
          }
        } else {
          data[searchField.prop] = searchField.value
        }
        // }
      })
      // let flag = validataObj(this.oldData, data)
      // if (flag) {
      //   return
      // }
      if (!changeProps.length) return
      this.oldData = data
      if (this.changeHandelFunction) this.changeHandelFunction(data)
      else this.$emit('change-filed', data, changeProps)
    },
    reset() {
      this.searchFilters.forEach(item => {
        item.value = ''
        item.min = ''
        item.max = ''
      })
      if (this.$refs.subDate) {
        const sList = Array.isArray(this.$refs.subDate) ? this.$refs.subDate : [this.$refs.subDate]
        for (const sd of sList) {
          sd.reset()
        }
      }
      this.onFiledChange()
    },
    getQuarterInstances() {
      if (this.$refs.subDate) {
        if (Array.isArray(this.$refs.subDate)) {
          return this.$refs.subDate
        }
        return [this.$refs.subDate]
      }
      return []
    },
  },
  beforeDestroy() {
    console.log('search-filter beforeDestroy')
  }
}
</script>

<style scoped>
.text-center {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
